export const FORGOT_PASSWORD_PATH = '/api/v1/auth/sparemin/forgot-password';
export const LOGIN_PATH = '/api/v1/auth/sparemin';
export const REGISTER_USER_PATH = '/api/v1/auth/sparemin/register';
export const RESET_PASSWORD_PATH = '/api/v1/auth/sparemin/reset-password';

// sparemin error codes
export const UNREGISTERED_EMAIL_ERROR_CODE = 401;
export const RESET_PASSWORD_TOKEN_ERROR_CODE = 402;

// http error codes
export const LOGIN_ERROR_STATUS = 422;
